import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, Loader } from 'core/components';
import { isSome } from 'core/utils';

function SyncInventoryForSellerTemplate({
	syncInventoryForSellerViewStore: { form, loading, sellerDropdownStore, isSyncing, isSuperAdminOrganization },
	t,
}) {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">{t('Sync Inventory')}</h2>
				</div>
				<div className="ReactModal__body">
					<BaasicDropdown isDisabled={!isSuperAdminOrganization} dropdownStore={sellerDropdownStore} isClearable={true} label={t('Seller')} />
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={!isSome(sellerDropdownStore.value)} >
						{isSyncing && <i className="icon icon--xmed icon--sync-loader spc--right--sml"></i>}
						{isSyncing ? t('Syncing inventory...') : t('Sync')}
					</button>
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(SyncInventoryForSellerTemplate);
